import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {Mail2SmsConfigFilter} from "./mail2SmsConfig.filter";
import { debounceTime } from 'rxjs/operators';
import {AlertService} from "../../services/alert.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'micro-mail2SmsConfigs',
  templateUrl: './mail2SmsConfigs.component.html'
})
export class Mail2SmsConfigsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:Mail2SmsConfigFilter = new Mail2SmsConfigFilter();
  defaultConfig:any;
  isRoot = false;
  editDefault = false;


  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              private alertService:AlertService,
              private route: ActivatedRoute,
              private router:Router) {

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.isRoot = this.auth.isSystemUser();
    this.editDefault = (this.auth.hasRole("COMPANY_ADMIN") && this.auth.hasRole("MAIL2SMS_ADMIN")) || this.isRoot;
    this.http.get(`${this.env.e.url}/mail2sms/mail2SmsConfigs/default`).subscribe(
      data => {
        this.setDefaultConfig(data)
      }
      );
    this.reload();
  }

  ngOnDestroy() {
  }

  setDefaultConfig(config:any) {
    this.defaultConfig = config;

    this.defaultConfig.postmasterId = this.defaultConfig.postmasterId === null ? undefined : this.defaultConfig.postmasterId;
    this.defaultConfig.smsEmailDomain = this.defaultConfig.smsEmailDomain === null ? undefined : this.defaultConfig.smsEmailDomain;
    this.defaultConfig.waEmailDomain = this.defaultConfig.waEmailDomain === null ? undefined : this.defaultConfig.waEmailDomain;
    this.defaultConfig.waMsisdn = undefined;
    this.defaultConfig.defaultMoToEmailOnlyNoRecipient = this.defaultConfig.defaultMoToEmailOnlyNoRecipient === null ? undefined : this.defaultConfig.defaultMoToEmailOnlyNoRecipient;
    this.defaultConfig.autoMoToLastEmail = this.defaultConfig.autoMoToLastEmail === null ? undefined : this.defaultConfig.autoMoToLastEmail;
    this.defaultConfig.autoMoToLastEmailHours = this.defaultConfig.autoMoToLastEmailHours === null ? undefined : this.defaultConfig.autoMoToLastEmailHours;
    this.defaultConfig.autoMoToMaxLastEmails = this.defaultConfig.autoMoToMaxLastEmails === null ? undefined : this.defaultConfig.autoMoToMaxLastEmails;
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/mail2sms/mail2SmsConfigs`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  updateDefaultConfig() {
    if (this.auth.isSystemUser() || (this.auth.hasRole("MAIL2SMS_ADMIN") && this.auth.hasRole("COMPANY_ADMIN"))) {
      this.http.put(`${this.env.e.url}/mail2sms/mail2SmsConfigs/${this.defaultConfig.id}`, this.defaultConfig)
        .subscribe(
          data => {
            this.setDefaultConfig(data);
            this.alertService.info(`System Defaults Updated`);
          }
        );
    }
  }

  isNullOrUndefined(check) {
    return check === null || check === undefined;
  }
}
